<template>
  <div class="info-item">
    <YorkbbsImage class="info-cover" :src="coverImage" animation target="_blank" :link="detailURL"></YorkbbsImage>
    <div class="info-desc">
      <a class="info-title e" target="_blank" :href="detailURL">{{ title }}</a>
      <div class="info-address" v-if="showColName.includes('address')">地址：{{ address }}</div>
      <div class="info-user" v-if="showColName.includes('contactName')">联系人：{{ contactName }}</div>
      <div class="info-tel" v-if="showColName.includes('contactNumber')">
        联系电话：{{ contactNumber | phoneFormat }}
      </div>
      <div class="info-extend" v-if="showColName.includes('extend1')">{{ extend1 }}</div>
      <div class="info-extend" v-if="showColName.includes('extend2')">{{ extend2 }}</div>
      <ul class="info-tag__list" v-if="showColName.includes('tags')">
        <li class="info-tag__item" v-for="(item, i) in tags" :key="i">{{ item }}</li>
      </ul>
      <div class="info-reason e" v-if="showColName.includes('reason')">推荐理由：{{ reason }}</div>
      <div class="info-level" v-if="showColName.includes('level')">
        推荐指数：<el-rate
          class="info-rate"
          v-model="level"
          disabled
          :colors="['#E43A3A', '#E43A3A', '#E43A3A']"
        ></el-rate>
      </div>
    </div>
  </div>
</template>
<script>
import { hostBuild } from '@/utils/utils';
export default {
  name: 'ItemInfo',
  props: {
    data: Object,
  },
  computed: {
    title() {
      return this.data.title;
    },
    coverImage() {
      return this.data.coverImage;
    },
    address() {
      return this.data.address;
    },
    contactName() {
      return this.data.contactName;
    },
    contactNumber() {
      return this.data.contactNumber;
    },
    tags() {
      return (this.data.tags.split(',') || []).slice(0, 5).filter(item => !!item);
    },
    reason() {
      return this.data.reason;
    },
    level() {
      return this.data.level;
    },
    detailURL() {
      if (this.data.app == 'bbs_post') {
        return hostBuild(`/detail/${this.data.postId}?topic=${this.data.topic.englishName}`, 'forum');
      }
      if (this.data.app == 'cms_post') {
        return hostBuild(`/detail/${this.data.topic.englishName}/${this.data.postId}`, 'news');
      }
      return `/detail/${this.data.topic.englishName}/${this.data.postId}`;
    },
    showColName() {
      return this.data.showColName;
    },
    extend1() {
      return this.data.extend1;
    },
    extend2() {
      return this.data.extend2;
    },
  },
};
</script>
<style lang="scss" scoped>
.info-item {
  display: flex;
}
.info-cover {
  width: 160px;
  height: 120px;
  border-radius: 4px;
}
.info-desc {
  overflow: hidden;
  flex: 1;
  padding-left: 20px;
}
.info-title {
  display: block;
  font-size: 18px;
  line-height: 25px;
  font-weight: 500;
  margin-bottom: 10px;
  &:hover {
    color: var(--primary-color);
  }
}
.info-reason {
  font-size: 14px;
  line-height: 20px;
  color: var(--text-color-9);
}

.info-address,
.info-user,
.info-tel,
.info-level,
.info-extend {
  font-size: 14px;
  line-height: 20px;
  color: var(--text-color-9);
  display: flex;
  align-items: center;
}
.info-address,
.info-user,
.info-tel,
.info-reason,
.info-extend {
  margin-bottom: 10px;
}

.info-tag__list {
  display: flex;
  flex-wrap: wrap;
}
.info-tag__item {
  font-size: 14px;
  color: var(--text-color-3);
  line-height: 28px;
  padding: 0 10px;
  background-color: #f8f8f8;
  border-radius: 4px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.info-rate {
  ::v-deep {
    .el-rate__icon {
      margin-right: 2px;
    }
  }
}
</style>
